const KEYS = {
  added: 'isSuggestedCartAdded',
  modified: 'isSuggestedCartModified'
} as const

export function setSuggestedCartAdded (value: boolean): void {
  localStorage.setItem(KEYS.added, value ? 'true' : 'false')
}

export function setSuggestedCartModified (value: boolean): void {
  localStorage.setItem(KEYS.modified, value ? 'true' : 'false')
}

export function getSuggestedCartAdded (): boolean {
  return localStorage.getItem(KEYS.added) === 'true'
}

export function getSuggestedCartModified (): boolean {
  return localStorage.getItem(KEYS.modified) === 'true'
}

export function clearSuggestedCartAdded (): void {
  localStorage.removeItem(KEYS.added)
}

export function clearSuggestedCartModified (): void {
  localStorage.removeItem(KEYS.modified)
}

export function clearSuggestedCartFlags (): void {
  localStorage.removeItem(KEYS.added)
  localStorage.removeItem(KEYS.modified)
}
